const mapTargets = document.querySelectorAll(".p-informationMap__itemWrap");
const mapTriggers = document.querySelectorAll(".p-informationMap__itemText");
const icon = document.querySelectorAll(".p-informationMap__itemText .c-btn__icon img")

for(let i = 0; i < mapTriggers.length; i++){
    mapTriggers[i].addEventListener("click", function(){
        mapTargets[i].classList.toggle("is-active");
        icon[i].classList.toggle("is-active");
    });
};